module.exports = __webpack_public_path__ + "img/ski_sub_title9m.5bef8850.jpg";